import { UITypes } from 'LibNeo'

export enum NUMBERS_USTAV {
	ONE = 1,
	TWO = 2,
	THREE = 3,
	FOUR = 4,
	FIVE = 5,
	SIX = 6,
	SEVEN = 7,
	EIGHT = 8,
	NINE = 9,
	TEN = 10,
	ELEVEN = 11,
	TWELVE = 12,
	THIRTEEN = 13,
	FOURTEEN = 14,
	FIFTEEN = 15,
	SIXTEEN = 16,
	SEVENTEEN = 17,
	EIGHTEEN = 18,
	NINETEEN = 19,
	TWENTY = 20,
	TWENTY_ONE = 21,
	TWENTY_TWO = 22,
	TWENTY_THREE = 23,
	TWENTY_FOUR = 24,
	TWENTY_FIVE = 25,
	TWENTY_SIX = 26,
	TWENTY_SEVEN = 27,
	TWENTY_EIGHT = 28,
	TWENTY_NINE = 29,
	THIRTY = 30,
	THIRTY_ONE = 31,
	THIRTY_TWO = 32,
	THIRTY_THREE = 33,
	THIRTY_FOUR = 34,
	THIRTY_FIVE = 35,
	THIRTY_SIX = 36,
}

export const TRANSLATE_NUMBER_USTAV = {
	[NUMBERS_USTAV.ONE]: 'Устав №1',
	[NUMBERS_USTAV.TWO]: 'Устав №2',
	[NUMBERS_USTAV.THREE]: 'Устав №3',
	[NUMBERS_USTAV.FOUR]: 'Устав №4',
	[NUMBERS_USTAV.FIVE]: 'Устав №5',
	[NUMBERS_USTAV.SIX]: 'Устав №6',
	[NUMBERS_USTAV.SEVEN]: 'Устав №7',
	[NUMBERS_USTAV.EIGHT]: 'Устав №8',
	[NUMBERS_USTAV.NINE]: 'Устав №9',
	[NUMBERS_USTAV.TEN]: 'Устав №10',
	[NUMBERS_USTAV.ELEVEN]: 'Устав №11',
	[NUMBERS_USTAV.TWELVE]: 'Устав №12',
	[NUMBERS_USTAV.THIRTEEN]: 'Устав №13',
	[NUMBERS_USTAV.FOURTEEN]: 'Устав №14',
	[NUMBERS_USTAV.FIFTEEN]: 'Устав №15',
	[NUMBERS_USTAV.SIXTEEN]: 'Устав №16',
	[NUMBERS_USTAV.SEVENTEEN]: 'Устав №17',
	[NUMBERS_USTAV.EIGHTEEN]: 'Устав №18',
	[NUMBERS_USTAV.NINETEEN]: 'Устав №19',
	[NUMBERS_USTAV.TWENTY]: 'Устав №20',
	[NUMBERS_USTAV.TWENTY_ONE]: 'Устав №21',
	[NUMBERS_USTAV.TWENTY_TWO]: 'Устав №22',
	[NUMBERS_USTAV.TWENTY_THREE]: 'Устав №23',
	[NUMBERS_USTAV.TWENTY_FOUR]: 'Устав №24',
	[NUMBERS_USTAV.TWENTY_FIVE]: 'Устав №25',
	[NUMBERS_USTAV.TWENTY_SIX]: 'Устав №26',
	[NUMBERS_USTAV.TWENTY_SEVEN]: 'Устав №27',
	[NUMBERS_USTAV.TWENTY_EIGHT]: 'Устав №28',
	[NUMBERS_USTAV.TWENTY_NINE]: 'Устав №29',
	[NUMBERS_USTAV.THIRTY]: 'Устав №30',
	[NUMBERS_USTAV.THIRTY_ONE]: 'Устав №31',
	[NUMBERS_USTAV.THIRTY_TWO]: 'Устав №32',
	[NUMBERS_USTAV.THIRTY_THREE]: 'Устав №33',
	[NUMBERS_USTAV.THIRTY_FOUR]: 'Устав №34',
	[NUMBERS_USTAV.THIRTY_FIVE]: 'Устав №35',
	[NUMBERS_USTAV.THIRTY_SIX]: 'Устав №36',
}

export enum CRITERION_USTAV {
	FIRST = 'first',
	SECOND = 'second',
	THREE = 'three',
	FOUR = 'four',
	FIVE = 'five',
	SIX = 'six',
	SEVEN = 'seven',
}

export enum TYPE_CRITERION_USTAV {
	BOOLEAN = 'boolean',
	SELECT = 'select',
}

export const CRITERION_USTAV_TYPES = {
	[CRITERION_USTAV.FIRST]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.SECOND]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.THREE]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.FOUR]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.FIVE]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.SIX]: TYPE_CRITERION_USTAV.BOOLEAN,
	[CRITERION_USTAV.SEVEN]: TYPE_CRITERION_USTAV.SELECT,
}

export const DEFAULT_CRETIONS = {
	[CRITERION_USTAV.FIRST]: false,
	[CRITERION_USTAV.SECOND]: false,
	[CRITERION_USTAV.THREE]: false,
	[CRITERION_USTAV.FOUR]: false,
	[CRITERION_USTAV.FIVE]: false,
	[CRITERION_USTAV.SIX]: false,
	[CRITERION_USTAV.SEVEN]: undefined,
}

export const TRANSLATE_CRITERION_USTAV = {
	[CRITERION_USTAV.FIRST]: 'Возможность выхода участника из общества',
	[CRITERION_USTAV.SECOND]: 'Необходимо получать согласие на отчуждение доли другим участникам',
	[CRITERION_USTAV.THREE]: 'Необходимо получать согласие на отчуждение доли третьим лицам',
	[CRITERION_USTAV.FOUR]: 'Преимущественное право покупки доли у участников общества',
	[CRITERION_USTAV.FIVE]:
		'Необходимо получать согласие на отчуждение доли наследникам и правопреемникам участников',
	[CRITERION_USTAV.SIX]: 'Решение общего собрания удостоверяется нотариусом',
}

export const CRITERION_BASE_USTAV = [
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Возможность выхода участника из общества',
	},
	{
		icon: 'close',
		color: UITypes.PASSIVE,
		name: 'Необходимо получать согласие на отчуждение доли другим участникам',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Необходимо получать согласие на отчуждение доли третьим лицам',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Преимущественное право покупки доли у участников общества',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Необходимо получать согласие на отчуждение доли наследникам и правопреемникам участников',
	},
	{
		icon: 'close',
		color: UITypes.PASSIVE,
		name: 'Решение общего собрания удостоверяется нотариусом',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Возможность использовать для общества с лицензируемой деятельностью',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Возможность использования печати',
	},
	{
		icon: 'check',
		color: UITypes.PRIMARY,
		name: 'Возможность использовать для ООО с 15 и более учредителями',
	},
	{
		icon: 'info',
		color: UITypes.PASSIVE,
		name: 'Единоличный исполнительный орган: Одно лицо (генеральный директор)',
	},
]

export enum TYPE_USTAV {
	FNS = 'fns',
	BASE = 'base',
	INDIVIDUAL = 'individual',
}

export const TRANSLATE_TYPE_USTAV = {
	[TYPE_USTAV.BASE]: 'Базовый',
	[TYPE_USTAV.FNS]: 'Типовой ФНС',
	[TYPE_USTAV.INDIVIDUAL]: 'Индивидуальный',
}

export enum TYPE_MODAL_USTAV {
	VIEW = 'view',
	HELPER = 'helper',
}

export enum SOLE_EXECUTIVE_BODY {
	ONE_PERSON = 'one_person',
	SELF_ACTING_DIRECTORS = 'self_acting_directors',
	JOINT_DIRECTORS = 'joint_directors',
}

export const TRANSLATE_SOLE_EXECUTIVE_BODY = {
	[SOLE_EXECUTIVE_BODY.ONE_PERSON]: 'Одно лицо (генеральный директор)',
	[SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS]: 'Самостоятельно действующие директора',
	[SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS]: 'Совместно действующие директора',
}

export const optionsSoleExecutiveBody = [
	{
		id: SOLE_EXECUTIVE_BODY.ONE_PERSON,
		name: TRANSLATE_SOLE_EXECUTIVE_BODY[SOLE_EXECUTIVE_BODY.ONE_PERSON],
	},
	{
		id: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
		name: TRANSLATE_SOLE_EXECUTIVE_BODY[SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS],
	},
	{
		id: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
		name: TRANSLATE_SOLE_EXECUTIVE_BODY[SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS],
	},
]

export const MATRIX_USTAV = {
	[NUMBERS_USTAV.ONE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWO]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.THREE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.FOUR]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.FIVE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.SIX]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.SEVEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.EIGHT]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.NINE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.ELEVEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TWELVE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.FOURTEEN]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.FIFTEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.SIXTEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.SEVENTEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.EIGHTEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: true,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.NINETEEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY_ONE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY_TWO]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY_THREE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY_FOUR]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.ONE_PERSON,
	},
	[NUMBERS_USTAV.TWENTY_FIVE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TWENTY_SIX]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TWENTY_SEVEN]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TWENTY_EIGHT]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.TWENTY_NINE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.SELF_ACTING_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_ONE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_TWO]: {
		[CRITERION_USTAV.FIRST]: true,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_THREE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_FOUR]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: false,
		[CRITERION_USTAV.THREE]: false,
		[CRITERION_USTAV.FOUR]: false,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_FIVE]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: false,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
	[NUMBERS_USTAV.THIRTY_SIX]: {
		[CRITERION_USTAV.FIRST]: false,
		[CRITERION_USTAV.SECOND]: true,
		[CRITERION_USTAV.THREE]: true,
		[CRITERION_USTAV.FOUR]: true,
		[CRITERION_USTAV.FIVE]: true,
		[CRITERION_USTAV.SIX]: false,
		[CRITERION_USTAV.SEVEN]: SOLE_EXECUTIVE_BODY.JOINT_DIRECTORS,
	},
}

export const CHIEF_POSITION_LIFE_TIME_YEARS_USTAV = (number: NUMBERS_USTAV) => {
	return [
		NUMBERS_USTAV.ONE,
		NUMBERS_USTAV.TWO,
		NUMBERS_USTAV.THREE,
		NUMBERS_USTAV.FOUR,
		NUMBERS_USTAV.FIVE,
		NUMBERS_USTAV.SIX,
		NUMBERS_USTAV.NINETEEN,
		NUMBERS_USTAV.TWENTY,
		NUMBERS_USTAV.TWENTY_ONE,
		NUMBERS_USTAV.TWENTY_TWO,
		NUMBERS_USTAV.TWENTY_THREE,
		NUMBERS_USTAV.TWENTY_FOUR,
	].includes(number)
		? 5
		: 0
}

export const POSITION_AND_CUSTOMER_USTAV = (number: NUMBERS_USTAV) => {
	return MATRIX_USTAV[number][CRITERION_USTAV.SEVEN] === SOLE_EXECUTIVE_BODY.ONE_PERSON
		? 'Генеральный директор'
		: 'Директор'
}
